module.exports = __webpack_public_path__ + "img/no_promocode.7cc96df5.png";